import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, FlutterIcon, HealthcareIcon, ReactIcon} from "../../../app-constants";
import {Link} from 'gatsby';

const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Native Android App Development',
        description: 'We yield leading-edge technologies like Kotlin, Java, and C++ to develop native Android apps. Our cost-effective solutions flawlessly integrate and scale, personalized to meet Denver\'s energetic business landscape. At TekRevol, our mobile and web app developers in Denver remain efficient on the latest tools and frameworks, turning visionary ideas into perceptible Denver success stories.',
    },
    {
        icon: IphoneIcon,
        title: 'Native IOS App Development',
        description: (
            <>
                Experience the summit of native {' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iOS app development
                </Link> {' '}
                from our team of professional iOS app developers in Denver. Our solutions impeccably scale across Apple devices – iPhone, iPad, Apple Watch, and Apple TV. Our Denver-based iOS developers skillfully wield Swift and Objective-C to create user-friendly apps that align with Apple's demanding standards.
            </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: 'Our professional game app development company in Denver uses recent technologies, and gaming engines like Unreal, Godot, CryEngine, and a lot more to build one-of-a-kind applications for you. Our game developers create addictive games with visually appealing gameplay, stunning graphics, and easy-to-understand rules that entices players to stick to their screens.',
    },
    {
        icon: FlutterIcon,
        title: 'Flutter app development',
        description: (
            <>
                Choosing our {' '}
                <Link to="/flutter-app-development" rel="noopener" aria-label="TekRevol">
                    Flutter app development services
                </Link> {' '}
                will help you build both iOS and Android applications using the same codebase due to the cross platform capabilities. We utilize this exceptional framework in the best way possible to design a stunning app. Hence, we cut the development time into half, and save up more with our quality-enriched mobile app development services.
            </>
        ),
    },
    {
        icon: HealthcareIcon,
        title: 'Hybrid App Development',
        description: "TekRevol's hybrid mobile app development team in Denver brings together skilled UX designers, creatives, and software engineers, prominent for developing maintainable, scalable hybrid apps. Utilizing our expertise, we facilitate our clients with both web and desktop experience. Hire our professional Hybrid app developers and let them handle all the app design and development work for you.",
    },
    {
        icon: ReactIcon,
        title: 'React Native app development',
        description: 'Experience excellence with our react native app development services in Denver, fully equipped with cutting-edge frameworks to build the most exceptional experiences. TekRevol has a team of professional react native app developers who own the skills to build applications that are sleek, robust, and captivating. With the optimal use of technology blended with innovation, we ensure 100% success to our customers.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>TekRevol’s Finest Mobile App Development Services in Denver</h2>
                        <p className="impro_para">Allow your business with personalized solutions offered by the leading Denver app development agency that drive success. Our custom-made expertise transforms visions into impactful realities, setting your venture on a path of growth. In the vibrant digital landscape of Colorado, we stand as an inspiration of innovation among mobile and web app development companies.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;